import { AsyncState } from "widgets-for-react";
import { loadKnowledgeTypeTeasersData } from "./knowledgeTypeTeasersApi";

export type KnowledgeTypeTeasersState = AsyncState<KnowledgeTypeTeasersData>;

export type KnowledgeTypeTeasersData = KnowledgeTypeTeaserData[];

export type KnowledgeTypeTeaserData = {
  KnowledgeType: string;
  Count: number;
};

export const initialKnowledgeTypeTeasersState: KnowledgeTypeTeasersState =
  loadKnowledgeTypeTeasersData;
